var map = {
	"./404.svg": 3927,
	"./build.svg": 4999,
	"./carControl.svg": 240,
	"./cascader.svg": 3221,
	"./chart.svg": 8155,
	"./clipboard.svg": 8029,
	"./color.svg": 3954,
	"./dadeng.svg": 8064,
	"./dangan.svg": 3308,
	"./dashboard.svg": 6683,
	"./date.svg": 4705,
	"./drag.svg": 4799,
	"./edit.svg": 1593,
	"./email.svg": 1903,
	"./example.svg": 7117,
	"./excel.svg": 4238,
	"./eye.svg": 3288,
	"./form.svg": 3495,
	"./fullscreen.svg": 6746,
	"./genzong.svg": 1969,
	"./github.svg": 5412,
	"./guanbi.svg": 4995,
	"./guide.svg": 4175,
	"./guiji.svg": 8577,
	"./job.svg": 5101,
	"./layer.svg": 584,
	"./lock.svg": 6592,
	"./log.svg": 6245,
	"./overview.svg": 6112,
	"./road.svg": 9487,
	"./system.svg": 9202,
	"./user.svg": 4692,
	"./xiaodeng.svg": 5792
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8202;